import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "assets/icons/search.svg";
import { useRTL } from "hooks/isRTL";

const SearchBar = ({ value, onSearch, placeholder }) => {
  const handleChange = (event) => {
    const newValue = event.target.value;
    onSearch(newValue);
  };

  const { t } = useRTL();

  return (
    <TextField
      value={value || ""}
      placeholder={ placeholder || t("ordersSearch")}
      variant="outlined"
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img
              src={SearchIcon}
              alt="Search Icon"
              style={{
                width: "20px",
                height: "20px",
                color: "text.placeholder",
              }}
            />
          </InputAdornment>
        ),
        sx: { padding: 1, height: "36px" },
      }}
      sx={{
        flex: 1,
        minWidth: "350px",
        height: "36px",
      }}
    />
  );
};

export default SearchBar;
